import { useEffect } from "react";
import Faq from "../../Components/Faq/Faq";
import Page from "../../Components/MetaPage/Page";
import { sendEvent } from "../../Utils/analytics";
import { getRemoteValue } from "../../Utils/firebase";
const FaqPage = () => {
  useEffect(() => {
    sendEvent(`view_faq_page`);
  }, []);

  return (
    <Page title={getRemoteValue("faq")}>
      <Faq />
    </Page>
  );
};

export default FaqPage;
